import React from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PageHeader from 'react-bootstrap/lib/PageHeader';
import * as customerActions from '../../../actions/customerActions';
import CustomerProfile from './CustomerProfile';
import { Customer } from '../../../propTypes';
import Col from '@coxautokc/fusion-ui-components/lib/Col';

const MockApiExamplePage = ({ customer, actions }) => (
  <div id="MockApi-Example">
    <PageHeader>Example: Mock API</PageHeader>
    <Col xs={6} md={6}>
      <p>
        Fusion generates realistic mock APIs using the combination of two
        technologies:
      </p>
      <ol>
        <li>
          <a
            href="https://github.com/json-schema-faker/json-schema-faker#more-examples"
            target="_blank"
            rel="noopener noreferrer"
          >
            JSON Schema Faker
          </a>{' '}
          - Generates realistic, random JSON data from a JSON Schema.
        </li>
        <li>
          <a href="https://github.com/typicode/json-server">json-server</a> -
          Serves a JSON file that mimics a real API.
        </li>
      </ol>
      When you type `npm start`, two things happen:
      <ol>
        <li>
          Fusion looks for src/api/mockDataSchema.js. If found, it generates
          /src/api/db.json based on the schema outlined in
          src/api/mockDataSchema.js.
        </li>
        <li>
          Fusion starts up a mock API using json-server and serves the
          mockDataSchema generated in step 1.
        </li>
      </ol>
      The example on the right does the following:
      <ul>
        <li>
          Loads the customer object that JSON Schema faker wrote to
          /src/api/db.json by making an API call to the mock data schema being
          hosted by json-server at{' '}
          <a href="http://localhost:3002/customer">
            http://localhost:3002/customer
          </a>.
        </li>
        <li>
          Field value changes are saved to /src/api/db.json when you click save.
          Reload this page, and you'll see that your changes are saved as though
          they were written to an actual database! Each time you run `npm
          start`, new mock data is generated, but your data persists as long as
          you keep the `npm start` process running.
        </li>
        <li>
          Example code for calling the API can be found at
          /src/actions/customerActions.js
        </li>
      </ul>
      <a href="https://ghe.coxautoinc.com/coxauto-ui/fusion-starter/blob/develop/README.md#how-does-the-mock-api-work">
        More info on this feature is available here
      </a>.
    </Col>

    <Col xs={6} md={6}>
      {customer.id && <CustomerProfile customer={customer} actions={actions} />}
    </Col>
  </div>
);

MockApiExamplePage.propTypes = {
  actions: object.isRequired,
  customer: Customer.isRequired
};

function mapStateToProps(state) {
  return {
    customer: state.customer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      customer: bindActionCreators(customerActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MockApiExamplePage);



// WEBPACK FOOTER //
// ./src/components/pages/MockApiExamplePage/MockApiExamplePage.js